import MockupSelect from './MockupSelect'

export default MockupSelect
